import { OffersSearchParamsType } from "@/app/oferty/types";
import { convertParamToObject } from "@/helpers/params.helper";
import { convertPage } from "@/helpers/pagination.helper";

export type OffersFilterType = {
  productType?: string,
  brand?: string,
  model?: string,
  price?: string[],
  states?: string[],
  course?: string[],
  year?: string[],
  capacity?: string[],
  power?: string[],
  bodyType?: string[],
  gearBox?: string[],
  fuel?: string[],
  invoice?: string[],
  sort?: string,
  page?: number,
}

export const convertOffersVariablesToFiltersObject = (params: string[], query: OffersSearchParamsType) => {
  const obj = {
    productType: "all",
    brand: null,
    model: null,
    price: [null, null],
    states: [],
    course: [null, null],
    year: [null, null],
    capacity: [null, null],
    power: [null, null],
    bodyType: [],
    gearBox: [],
    fuel: [],
    invoice: [],
    drive: null,
    sort: "date-desc",
    page: 0
  };

  if (params) {
    const productTypeParam = params[0];
    if (productTypeParam && ["car", "truck", "motorbikes"].includes(productTypeParam)) {
      obj.productType = productTypeParam;
    }

    const brandParam = params[1];
    if (brandParam && brandParam !== "all") {
      obj.brand = brandParam;
    }

    const modelParam = params[2];
    if (modelParam && modelParam !== "all") {
      obj.model = modelParam;
    }
  }

  const priceQuery = query.price;
  if (priceQuery) {
    // @ts-ignore
    obj.price = convertParamToObject(query.price);
  }

  const states = query.states;
  if (states) {
    obj.states = query.states.split(",");
  }

  const year = query.year;
  if (year) {
    // @ts-ignore
    obj.year = convertParamToObject(query.year);
  }

  const bodyType = query.bodyType;
  if (bodyType) {
    obj.bodyType = query.bodyType.split(",");
  }

  const gearBox = query.gearBox;
  if (gearBox) {
    obj.gearBox = query.gearBox.split(",");
  }

  const fuel = query.fuel;
  if (fuel) {
    obj.fuel = query.fuel.split(",");
  }

  const invoice = query.invoice;
  if (invoice) {
    obj.invoice = query.invoice.split(",");
  }

  const course = query.course;
  if (course) {
    // @ts-ignore
    obj.course = convertParamToObject(query.course);
  }

  const capacity = query.capacity;
  if (capacity) {
    // @ts-ignore
    obj.capacity = convertParamToObject(query.capacity);
  }

  const power = query.power;
  if (power) {
    // @ts-ignore
    obj.power = convertParamToObject(query.power);
  }

  const sort = query.sort;
  if (sort) {
    // @ts-ignore
    obj.sort = sort;
  }

  const p = query.p;
  if (p) {
    // @ts-ignore
    obj.page = convertPage(p);
  }

  return obj;
};

export const convertOffersFiltersObjectToServiceFilters = (obj?: OffersFilterType) => {
  const params = new URLSearchParams({});
  params.set("size", "25");
  if (obj.productType && obj.productType !== "all") {
    params.set("productTypes", obj.productType);
  }
  if (obj.brand) {
    params.set("brand", obj.brand);
  }
  if (obj.model) {
    params.set("model", obj.model);
  }
  if (obj.states && obj.states.length > 0) {
    params.set("states", obj.states.join(","));
  }
  if (obj.bodyType && obj.bodyType.length > 0) {
    params.set("bodyTypes", obj.bodyType.join(","));
  }
  if (obj.gearBox && obj.gearBox.length > 0) {
    params.set("gearBoxTypes", obj.gearBox.join(","));
  }
  if (obj.fuel && obj.fuel.length > 0) {
    params.set("fuelTypes", obj.fuel.join(","));
  }
  if (obj.invoice && obj.invoice.length > 0) {
    params.set("invoiceTypes", obj.invoice.join(","));
  }
  if (obj.price && obj.price[0] && obj.price[0] != "null") {
    params.set("minPrice", obj.price[0]);
  }
  if (obj.price && obj.price[1] && obj.price[1] != "null") {
    params.set("maxPrice", obj.price[1]);
  }
  if (obj.year && obj.year[0] && obj.year[0] != "null") {
    params.set("minYear", obj.year[0]);
  }
  if (obj.year && obj.year[1] && obj.year[1] != "null") {
    params.set("maxYear", obj.year[1]);
  }
  if (obj.capacity && obj.capacity[0] && obj.capacity[0] != "null") {
    params.set("minEngineCapacity", obj.capacity[0]);
  }
  if (obj.capacity && obj.capacity[1] && obj.capacity[1] != "null") {
    params.set("maxEngineCapacity", obj.capacity[1]);
  }
  if (obj.power && obj.power[0] && obj.power[0] != "null") {
    params.set("minEnginePower", obj.power[0]);
  }
  if (obj.power && obj.power[1] && obj.power[1] != "null") {
    params.set("maxEnginePower", obj.power[1]);
  }
  if (obj.course && obj.course[0] && obj.course[0] != "null") {
    params.set("minCourse", obj.course[0]);
  }
  if (obj.course && obj.course[1] && obj.course[1] != "null") {
    params.set("maxCourse", obj.course[1]);
  }
  if (obj.sort) {
    params.set("sortType", obj.sort.split("-")[0]);
    params.set("sort", obj.sort.split("-")[1]);
  }
  if (obj.page) {
    params.set("page", obj.page.toString());
  }

  return params;
};

export const convertFiltersObjectToCMSSlug = (obj: OffersFilterType) => {
  return `${obj.productType}${obj.brand !== "" ? `-${obj.brand}` : ""}${obj.model !== "" ? `-${obj.model}` : ""}`
}
